import { ApiService } from './../../services/apiservice/apiservice.service';
import { StorageService } from './../../services/storage/storage.service';
import { ConfigService } from './../../services/config/config.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedService } from './../../services/shared/shared.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class KidsCatalogSearchService {
  searchReqKidsKey = '_sea_req_kids';
  url = '';
  readonly kidsCatKey: string = 'kidsResults';
  readonly kidsCatKeyOG: string = 'kidsResultsOG';

  constructor(
    private _apiService: ApiService,
    private _configService: ConfigService,
    private _http: HttpClient,
    private _router: Router,
    private _sharedService: SharedService,
    private _storageService: StorageService,
  ) {}

  setKidsCacheSearchRequest(value) {
    this._storageService.setItem(this.searchReqKidsKey, value);
  }

  getKidsCacheSearchRequest() {
    return this._storageService.getItem(this.searchReqKidsKey);
  }

  kidsCatBindingsandRouting(results, searchId, QUERY = '') {
    if (QUERY !== '') {
      this._storageService.setItem('Search-TERM', QUERY);
    }
    this.setKidsCatalogResultsCached(results);
    this.setKidsCatalogResultsOriginalCached(results); // set orginal copy i cache for quick restoration of original results
    this._storageService.setItem('facetFilterArray', []);
    const Cid = this._storageService.getCid();
    const Lid = this._storageService.getLid();
    // back img icon on search
    this._storageService.setBackFrmKC('/kids');
    this._router.navigate(['/search', Cid, Lid], {
      queryParams: {
        searchId: searchId,
        startRecord: 1,
        d: Date.now(), // TODO may be used to trigger reload for routing purposes
      },
    });
  }

  async getKidsCategoriesAsync(): Promise<any> {
    this.url = `${this._configService.searchApi}/kids`;
    const response: any = await this._http.get(this.url).toPromise();
    return response;
  }

  async getKidsCatAsync(): Promise<any> {
    let data = null;
    const kidsResponse = await this.getKidsCategoriesAsync();
    if (kidsResponse && kidsResponse.status == 'OK' && kidsResponse.message == 'Success') {
      data = kidsResponse.data;
    } else {
      this._sharedService.openSnackBar(kidsResponse.message);
    } // error
    return data;
  }

  getEachCategory(id): Observable<any> {
    this.url = this._configService.searchApi + '/kids/' + id;
    return this._apiService.get(this.url);
  }

  async performKidsSearchAsync(postInfo): Promise<any> {
    this.url = `${this._configService.searchApi}/kids/search`;
    const response: any = await this._http.post(this.url, postInfo).toPromise();
    if (response && response.status == 'OK' && response.message == 'Success') {
      return response.data;
    } else {
      this._sharedService.openSnackBar(response.message);
    }
    return null;
  }

  performSearch(payload) {
    //make this a normal search with the kids flag
    this.url = `${this._configService.searchApi}/kids/search`;

    return this._apiService.post(this.url, payload).pipe(
      map((response) => {
        if (response.data) {
          this.setKidsCatalogResultsCached(response.data);
          return response.data;
        } else {
          throw new Error(response.message);
        }
      }),
    );
  }

  setKidsCatalogResultsOriginalCached(value): void {
    this._storageService.setItem(this.kidsCatKeyOG, value);
  }

  getKidsCatalogResultsOriginalCached(): object {
    return this._storageService.getItem(this.kidsCatKeyOG);
  }

  setKidsCatalogResultsCached(value): void {
    this._storageService.setItem(this.kidsCatKey, value);
  }

  getKidsCatalogResultsCached() {
    return this._storageService.getItem(this.kidsCatKey);
  }

  removeKidsCatalogResultsCached() {
    return this._storageService.remove(this.kidsCatKey);
  }
}
